"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _AdaptiveCardRenderer = _interopRequireDefault(require("./AdaptiveCardRenderer"));

function stripSubmitAction(card) {
  if (!card.actions) {
    return card;
  } // Filter out HTTP action buttons


  var nextActions = card.actions.filter(function (action) {
    return action.type !== 'Action.Submit';
  }).map(function (action) {
    return action.type === 'Action.ShowCard' ? (0, _objectSpread2.default)({}, action, {
      card: stripSubmitAction(action.card)
    }) : action;
  });
  return (0, _objectSpread2.default)({}, card, {
    nextActions: nextActions
  });
}

var AdaptiveCardAttachment =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(AdaptiveCardAttachment, _React$Component);

  function AdaptiveCardAttachment(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AdaptiveCardAttachment);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AdaptiveCardAttachment).call(this, props));
    _this.createAdaptiveCard = (0, _memoizeOne.default)(function (adaptiveCards, content) {
      var card = new adaptiveCards.AdaptiveCard();
      var errors = []; // TODO: [P3] Move from "onParseError" to "card.parse(json, errors)"

      adaptiveCards.AdaptiveCard.onParseError = function (error) {
        return errors.push(error);
      };

      card.parse(stripSubmitAction((0, _objectSpread2.default)({
        version: '1.0'
      }, content)));
      adaptiveCards.AdaptiveCard.onParseError = null;
      return {
        card: card,
        errors: errors
      };
    });
    return _this;
  }

  (0, _createClass2.default)(AdaptiveCardAttachment, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          adaptiveCardHostConfig = _this$props.adaptiveCardHostConfig,
          adaptiveCards = _this$props.adaptiveCards,
          attachment = _this$props.attachment,
          renderMarkdown = _this$props.renderMarkdown;

      var _this$createAdaptiveC = this.createAdaptiveCard(adaptiveCards, attachment.content, renderMarkdown),
          card = _this$createAdaptiveC.card;

      return _react.default.createElement(_AdaptiveCardRenderer.default, {
        adaptiveCard: card,
        adaptiveCardHostConfig: adaptiveCardHostConfig
      });
    }
  }]);
  return AdaptiveCardAttachment;
}(_react.default.Component);

exports.default = AdaptiveCardAttachment;
AdaptiveCardAttachment.propTypes = {
  // TODO: [P2] We should rename adaptiveCards to adaptiveCardsPolyfill
  adaptiveCardHostConfig: _propTypes.default.any.isRequired,
  adaptiveCards: _propTypes.default.any.isRequired,
  attachment: _propTypes.default.shape({
    content: _propTypes.default.any.isRequired
  }).isRequired,
  renderMarkdown: _propTypes.default.any.isRequired
};